import CustomerCardContainer from '../../../../containers/common/customer/customerCard/customerCardContainer';

function CustomerCard(props) {
  const { customerId, refreshing, open, onClose } = props;

  return (
    <CustomerCardContainer
      refreshing={refreshing}
      customerId={customerId}
      open={open}
      onClose={onClose}
    />
  );
}

export default CustomerCard;
